import { WbTrapFocus } from './WbTrapFocus';

class WbTimeline {
  constructor() {
    this.init();
  }

  init() {
    this.bindListeners();
    this.autoloadTimeline();
  }

  bindListeners() {
    const _this = this;

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.js-open-timeline', _this.openTimeline.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener(
        'click',
        '.wb-publication-timeline__accordion__substeps .js-toggle-accordion',
        _this.toggleSubstep.bind(_this)
      );

    document
      .querySelector('body')
      ._addCustomEventListener(
        'click',
        '.wb-publication-timeline__accordion__toggle--overlay',
        _this.toggleStep.bind(_this)
      );

    document
      .querySelector('body')
      ._addCustomEventListener(
        'click',
        '.wb-publication-timeline__close',
        _this.closeTimeline.bind(_this)
      );

    document.addEventListener('keydown', _this.keydownEventListener.bind(_this));
  }

  toggleAjaxOverlay() {
    const overlayIsActive = document.querySelector('body').classList.contains('load-overlay');

    if (!overlayIsActive) {
      const icon = document.createElement('div');
      icon.classList.add('load-overlay__icon');

      document.querySelector('body').classList.add('load-overlay');
      document.querySelector('body').appendChild(icon);
    } else {
      document.querySelector('.load-overlay').classList.remove('load-overlay');
      document.querySelector('.load-overlay__icon').remove();
    }
  }

  toggleStep(e) {
    const target = e.targetElement;
    const parent = target?.closest('.wb-publication-timeline__accordion--overlay');
    const content = parent?.querySelector('.wb-publication-timeline__accordion__content');
    const activeElements = document.querySelectorAll(
      '.wb-publication-timeline__accordion__toggle--overlay[aria-expanded="true"]'
    );
    const isLinear = document.querySelector('.wb-overlay.wb-publication-timeline--linear');
    const currentStep = parent.getAttribute('data-step');

    activeElements?.forEach((element) => {
      if (target == element) return;

      const activeParent = element.closest('.wb-publication-timeline__accordion');

      element._toggleAriaExpanded();
      activeParent?.querySelector('.wb-publication-timeline__accordion__content')._slideToggle();
      activeParent?.classList.remove('is-active');
    });

    parent?.classList.toggle('is-active');
    target?._toggleAriaExpanded();
    content?._slideToggle().then(() => parent.scrollIntoView({ behavior: 'smooth' }));

    this.toggleLinearSteps(isLinear, currentStep);
  }

  toggleSubstep(e) {
    const target = e.targetElement ?? e;
    const parent = target?.closest('.wb-publication-timeline__accordion');
    const substeps = target?.closest('.wb-publication-timeline__accordion__substeps');
    const content = parent?.querySelector('.wb-publication-timeline__accordion__content');
    const activeElements = substeps.querySelectorAll(
      '.wb-publication-timeline__accordion__toggle[aria-expanded="true"]'
    );

    activeElements?.forEach((element) => {
      if (target == element) return;

      element._toggleAriaExpanded();
      element
        .closest('.wb-publication-timeline__accordion')
        ?.querySelector('.wb-publication-timeline__accordion__content')
        ._slideToggle();
    });

    target?._toggleAriaExpanded();
    content?._slideToggle().then(() => parent.scrollIntoView({ behavior: 'smooth' }));

    if (substeps) {
      const expanded = target.getAttribute('aria-expanded') == 'true';
      const elements = substeps.querySelectorAll('.wb-publication-timeline__accordion__toggle');

      elements?.forEach((el) => {
        el.classList.remove('is-not-active');
        if (target == el) return;
        if (expanded) el.classList.add('is-not-active');
      });
    }
  }

  keydownEventListener(e) {
    const overlay = document.querySelector('#wb-publication-timeline');
    const isOpen = overlay?.classList.contains('wb-overlay--open');

    if (!isOpen) return;

    switch (e.key) {
      case 'Escape':
        this.closeTimeline();
        break;
    }
  }

  closeTimeline() {
    const overlay = document.querySelector('.wb-overlay');

    overlay._hide(0.5).then(() => overlay.remove());

    this.refTrigger?.focus();
    this.refTrigger = false;

    document.querySelector('html, body').classList.remove('wb-overlay--active');
  }

  openTimeline(e, id = 0, step = 1, substep = null) {
    const target = e?.targetElement;
    const publication_id = target?.getAttribute('data-publication-id') ?? id;
    const currentStep = target?.getAttribute('data-timeline-step') ?? step - 1;

    if (!publication_id) return;

    this.refTrigger = target;

    this.fetchTimeline(publication_id).then(() => {
      const overlay = document.querySelector('.wb-overlay');

      if (overlay) {
        const activeStep = overlay.querySelector(`[data-step="${currentStep}"]`);
        const isLinear = overlay.classList.contains('wb-publication-timeline--linear');

        this.WbTrapFocus = new WbTrapFocus({
          ele: overlay,
          activeClass: 'wb-overlay--open',
        });

        activeStep
          .querySelector('.wb-publication-timeline__accordion__toggle')
          ._toggleAriaExpanded();
        activeStep.querySelector('.wb-publication-timeline__accordion__content')._slideDown(0);
        activeStep.classList.add('is-active');
        activeStep.focus();

        this.toggleLinearSteps(isLinear, currentStep);

        if (substep) {
          const activeSubStep = activeStep.querySelector(
            `.wb-publication-timeline__accordion__substeps [data-timeline-step="${substep - 1}"]`
          );
          this.toggleSubstep(activeSubStep);
        }

        document.querySelector('html, body').classList.add('wb-overlay--active');
      }
    });
  }

  toggleLinearSteps(isLinear, currentStep) {
    if (isLinear) {
      const elements = document.querySelectorAll('.wb-publication-timeline__accordion--overlay');

      elements?.forEach((el) => {
        const step = el.getAttribute('data-step');

        if (parseInt(step) > parseInt(currentStep) + 1) el._hide(0, false);
        else el._show(0, false);
      });
    }
  }

  fetchTimeline(id) {
    const _this = this;

    this.toggleAjaxOverlay();

    return new Promise((resolve, reject) => {
      fetch(ajaxurl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
        },
        body: `action=get_publication_timeline&publication_id=${id}`,
      })
        .then((response) => {
          if (!response.ok) {
            this.toggleAjaxOverlay();
            reject(response.statusText);
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.text())
        .then((data) => {
          const PARSER = new DOMParser();
          const DOC = PARSER.parseFromString(data, 'text/html');
          const timeline = DOC.querySelector('.wb-publication-timeline');

          if (timeline) {
            document.querySelector('body').appendChild(timeline);
            timeline._show(0.5);
            timeline.classList.add('wb-overlay--open');
          }

          _this.toggleAjaxOverlay();
          resolve();
        })
        .catch((error) => console.error(error));
    });
  }

  autoloadTimeline() {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const id = params.get('timeline_id');
    const step = params.get('timeline_step') ?? 1;
    const substep = params.get('timeline_substep');

    this.openTimeline(null, id, step, substep);
  }
}

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    window.WbTimeline = new WbTimeline();
  }
});
